import { TABLE_ELEMENTS as trans } from './translationValues';

export const tableElements = (t, currentLanguage = 'en') => {
  return [
    {
      id: 1129,
      name: 'Static Table',
      displayName: 'Static Table',
      thumbnail: `<svg width="80px" height="80px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 9H21M3 15H21M9 9L9 20M15 9L15 20M6.2 20H17.8C18.9201 20 19.4802 20 19.908 19.782C20.2843 19.5903 20.5903 19.2843 20.782 18.908C21 18.4802 21 17.9201 21 16.8V7.2C21 6.0799 21 5.51984 20.782 5.09202C20.5903 4.71569 20.2843 4.40973 19.908 4.21799C19.4802 4 18.9201 4 17.8 4H6.2C5.0799 4 4.51984 4 4.09202 4.21799C3.71569 4.40973 3.40973 4.71569 3.21799 5.09202C3 5.51984 3 6.07989 3 7.2V16.8C3 17.9201 3 18.4802 3.21799 18.908C3.40973 19.2843 3.71569 19.5903 4.09202 19.782C4.51984 20 5.07989 20 6.2 20Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
      isText: true,
      type: 'plain',
      htmlContent: `<table class="sc-eUNjYF bJqKHr" style="background-color: rgb(255, 255, 255);">` +
        `<tr style="height: 40px;">` +
          `<td style="border-width: 1px; border-style: solid; border-color: grey; width: 150px;"></td>` +
          `<td style="border-width: 1px; border-style: solid; border-color: grey; width: 150px;"></td>` +
          `<td style="border-width: 1px; border-style: solid; border-color: grey; width: 150px;"></td>` +
        `</tr>` +
        `<tr style="height: 40px;">` +
          `<td style="border-width: 1px; border-style: solid; border-color: grey; width: 150px;"></td>` +
          `<td style="border-width: 1px; border-style: solid; border-color: grey; width: 150px;"></td>` +
          `<td style="border-width: 1px; border-style: solid; border-color: grey; width: 150px;"></td>` +
        `</tr>` +
        `<tr style="height: 40px;">` +
          `<td style="border-width: 1px; border-style: solid; border-color: grey; width: 150px;"></td>` +
          `<td style="border-width: 1px; border-style: solid; border-color: grey; width: 150px;"></td>` +
          `<td style="border-width: 1px; border-style: solid; border-color: grey; width: 150px;"></td>` +
        `</tr>` +
      `</table>`,
      elementDetails: {
        contents: [
          {
            row: 1,
            column: 1,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              border: {
                thickness: 1,
                borderStyle: "SOLID",
                borderColor: "#000000",
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              backgroundColor: '#ffffff00'
            },
            contents: [
              {
                contentType: 'PARAGRAPH',
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                },
                content: ''
              },
              {
                contentType: "LINE_BREAK",
                content: "\n",
                style: {
                  lineSpacing: 1.5,
                  alignment: "center",
                  color: "#000000"
                }
              }
            ]
          },
          {
            row: 1,
            column: 2,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              border: {
                thickness: 1,
                borderStyle: "SOLID",
                borderColor: "#000000",
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              backgroundColor: '#ffffff00'
            },
            contents: [
              {
                contentType: 'PARAGRAPH',
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                },
                content: ''
              },
              {
                contentType: "LINE_BREAK",
                content: "\n",
                style: {
                  lineSpacing: 1.5,
                  alignment: "center",
                  color: "#000000"
                }
              }
            ]
          },
          {
            row: 1,
            column: 3,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              border: {
                thickness: 1,
                borderStyle: "SOLID",
                borderColor: "#000000",
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              backgroundColor: '#ffffff00'
            },
            contents: [
              {
                contentType: 'PARAGRAPH',
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                },
                content: ''
              },
              {
                contentType: "LINE_BREAK",
                content: "\n",
                style: {
                  lineSpacing: 1.5,
                  alignment: "center",
                  color: "#000000"
                }
              }
            ]
          },
          {
            row: 2,
            column: 1,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              border: {
                thickness: 1,
                borderStyle: "SOLID",
                borderColor: "#000000",
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              backgroundColor: '#ffffff00'
            },
            contents: [
              {
                contentType: 'PARAGRAPH',
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                },
                content: ''
              },
              {
                contentType: "LINE_BREAK",
                content: "\n",
                style: {
                  lineSpacing: 1.5,
                  alignment: "center",
                  color: "#000000"
                }
              }
            ]
          },
          {
            row: 2,
            column: 2,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              border: {
                thickness: 1,
                borderStyle: "SOLID",
                borderColor: "#000000",
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              backgroundColor: '#ffffff00'
            },
            contents: [
              {
                contentType: 'PARAGRAPH',
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                },
                content: ''
              },
              {
                contentType: "LINE_BREAK",
                content: "\n",
                style: {
                  lineSpacing: 1.5,
                  alignment: "center",
                  color: "#000000"
                }
              }
            ]
          },
          {
            row: 2,
            column: 3,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              border: {
                thickness: 1,
                borderStyle: "SOLID",
                borderColor: "#000000",
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              backgroundColor: '#ffffff00'
            },
            contents: [
              {
                contentType: 'PARAGRAPH',
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                },
                content: ''
              },
              {
                contentType: "LINE_BREAK",
                content: "\n",
                style: {
                  lineSpacing: 1.5,
                  alignment: "center",
                  color: "#000000"
                }
              }
            ]
          },
          {
            row: 3,
            column: 1,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              border: {
                thickness: 1,
                borderStyle: "SOLID",
                borderColor: "#000000",
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              backgroundColor: '#ffffff00'
            },
            contents: [
              {
                contentType: 'PARAGRAPH',
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                },
                content: ''
              },
              {
                contentType: "LINE_BREAK",
                content: "\n",
                style: {
                  lineSpacing: 1.5,
                  alignment: "center",
                  color: "#000000"
                }
              }
            ]
          },
          {
            row: 3,
            column: 2,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              border: {
                thickness: 1,
                borderStyle: "SOLID",
                borderColor: "#000000",
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              backgroundColor: '#ffffff00'
            },
            contents: [
              {
                contentType: 'PARAGRAPH',
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                },
                content: ''
              },
              {
                contentType: "LINE_BREAK",
                content: "\n",
                style: {
                  lineSpacing: 1.5,
                  alignment: "center",
                  color: "#000000"
                }
              }
            ]
          },
          {
            row: 3,
            column: 3,
            rowSpan: 1,
            columnSpan: 1,
            style: {
              border: {
                thickness: 1,
                borderStyle: "SOLID",
                borderColor: "#000000",
                left: true,
                top: true,
                bottom: true,
                right: true,
              },
              padding: {
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              backgroundColor: '#ffffff00'
            },
            contents: [
              {
                contentType: 'PARAGRAPH',
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                },
                content: ''
              },
              {
                contentType: "LINE_BREAK",
                content: "\n",
                style: {
                  lineSpacing: 1.5,
                  alignment: "center",
                  color: "#000000"
                }
              }
            ]
          }
        ],
        styles: {
          position: 'absolute',
          width: '450px',
          height: '120px',
          transform: 'translateX(0px) translateY(235px) rotate(0deg) scaleX(1) scaleY(1)',
          backgroundColor: 'transparent',
          border: {
            thickness: 1,
            borderStyle: 'SOLID',
            borderColor: '#000',
            left: true,
            top: true,
            right: true,
            bottom: true
          },
          tableProperties: {
            rows: 3,
            columns: 3,
            rowHeights: [40, 40, 40],
            columnWidths: [150, 150, 150],
          },
        },
        value: t(trans.STATIC_TABLE_LABEL.key, trans.STATIC_TABLE_LABEL.value),
        type: 'static_table',
      },
    },
  ];
};
